<template>
    <div>
        <el-dialog title="选择答题卡" width="60%"  :visible.sync="dialogVisible" :close-on-click-modal="false">
            <div class="search_container searchArea">
                <el-form :inline="true" :model='searchForm' ref="searchForm" class="demo-form-inline search-form">
                    <el-form-item label="答题卡名称">
                        <el-input v-model="searchForm.keyWord" placeholder="请输入答题卡名称"> </el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size ="mini" icon="search" @click='loadScantronList()'>查询</el-button>
                    </el-form-item>
                </el-form>
            </div>

            <div class="table_container">
                <el-table v-loading="loading" :data="tableData" height="400" style="width: 100%" align='center'  @selection-change="handleSelectionChange">
                    <!-- <el-table-column type="selection" width="55" ></el-table-column> -->
                    <el-table-column type="index" label="序号"  width="150" align='center' ></el-table-column>
                    <el-table-column prop="id" label="key"  width="150" align='center' ></el-table-column>
                    <el-table-column prop="name" label="答题卡名称"   align='center' ></el-table-column>
                    <el-table-column prop="createTime" label="创建时间"  width="150" align='center' ></el-table-column>
                    <el-table-column prop="operation" align='center' label="操作" width="300">
                        <template slot-scope='scope'>
                            <el-button icon='edit' size="mini" @click='showScantron(scope.row)'>预览</el-button>
                            <el-button icon='edit' size="mini" @click='openNewExam(scope.row)' type="primary">创建</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <pagination  :pageSize="searchForm.pageSize" :currentPage="searchForm.pageNo" :pageTotal="searchForm.totalCount" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"></pagination>
            </div>


            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
            </div>
        </el-dialog>

        <newExamDialog ref="newExamDialog" :newExam="selNewExam" ></newExamDialog>
    </div>


</template>

<script>
    import {mapGetters, mapState} from "vuex";
    import * as simpleApi from "request/simple";
    import XEUtils from 'xe-utils'
    import * as mUtils from '@/utils/mUtils'
    import Pagination from "@/components/pagination";
    import newExamDialog from "./newExamDialog";

import { create } from "underscore";

    export default {
        name: 'newExamByScantronDialog',
        data(){
            return {
                dialogVisible: false,
                dialogExamVisible: false,
                loading: false,
                searchForm:{ 
                    pageNo: 1, 
                    pageSize: 30, 
                    totalCount: 0, 
                    searchText: null, 
                    schoolId: null
                },
                // 多选列表
                multipleSelection: [],
                tableData: [], 
                examList: [],
                tableHeight:0,
                loading:true, 
                isShow:false,
                schoolList: [],
                professionList: [],
                selCource: null, 
                selCourceDtl: null,
                selNewExam: null, 
            }
        },
        components:{
            Pagination,newExamDialog
        },
        computed:{
            ...mapState({
                userInfo: state => state.user.userInfo,
            }),
        },
      	mounted() {

	    },
        props: {
        },
        watch: {
        },
        methods: { 
            showDialog(){
                this.loadScantronList()
                this.dialogVisible = true
            },
            loadScantronList(){
                // _: Date.now()  // 使用当前时间戳
        
                this.loading = true;
                let userId = this.userInfo.id
                let param = { pageIndex: this.searchForm.pageNo, pageSize: this.searchForm.pageSize, keyWord: this.searchForm.keyWord, userId: userId, _: Date.now()};
                return simpleApi.scantronGet(param).then((response) => {
                    const { status, data, message } = response;
                    if (status == 200) {
                        let result = data.data
                        this.loading = false;
                        this.tableData = result.list;
                        this.total = result.totalCount;
                        this.searchForm.totalCount =  result.totalCount;
                    }
                    }).catch((error) => {
                        this.loading = false;
                        console.log("error:", error);
                    });
            },

            // 上下分页
            handleCurrentChange(val){
                this.searchForm.pageNo = val;
                this.loadScantronList()
            },
            // 每页显示多少条
            handleSizeChange(val){
                this.searchForm.pageSize = val;
                this.loadScantronList()
            },
            // 预览答题卡
            showScantron(row){
              let htmlUrl = row.htmlUrl
              // let htmlUrl = 'https://sh-vknow-admin.obs.cn-east-3.myhuaweicloud.com:443/html/2049df50-67ac-4cb4-8197-382ff160625b.html?v=' + Date.now();
              // 判断考试答题卡是否存在
              fetch(htmlUrl + '?v=' + Date.now())
                  .then(response => {
                      if (!response.ok) {
                          throw new Error('网络响应不正常');
                      }
                      return response.text();
                  })
                  .then(htmlContent => {
                      // 在新窗口中显示 HTML
                      const newWindow = window.open('', '_blank');
                      newWindow.document.write(htmlContent);
                      newWindow.document.close();
                  })
                  .catch(error => {
                      console.error('打开失败:', error);
                      // 降级方案：直接打开（可能会下载）
                      window.open(htmlUrl, '_blank');
                  });
            },
            // 创建考试
            openNewExam(row){
                // 将选择的答题卡名称同步带到考试名称去
                this.selNewExam = { exam_time: new Date(), time: (new Date()).getMilliseconds(),scantronId: row.id,examName: row.name};
                this.$refs.newExamDialog.showDialog();
            },
        },
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">



</style>


